import {React, useState} from "react";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";

import history from "services/history"

import DashboardLayout from "layouts/Dashboard.js";
import AuthLayout from "layouts/Auth.js";
import PaymentSuccess from "views/vismapay/PaymentSuccess/PaymentSuccess"
import PaymentCancelled from "views/vismapay/PaymentCancelled/PaymentCancelled"
import { useAuthContext } from "contexts/AuthContext";
import ApiErrorNotifier from "components/ApiErrorNotifier/ApiErrorNotifier";
import SessionExpiryWarning from "components/SessionExpiryWarning/SessionExpiryWarning";
import DevLogin from "views/auth/DevLogin";
import { DEV_LOGIN_PATH, isDevLoginEnabled } from "services/devLogin";

import { Container, Row, Col } from "stories/layout";
import { Spinner } from "stories/components"

// ERP one-time dev-login links (/dl?t=…) exist only in the dev build. The route is in
// both switches: a browser that is already signed in must not have its catch-all
// redirect swallow the link.
const devLoginEnabled = isDevLoginEnabled(process.env.REACT_APP_ENV);

const App = () => {
  const { isAuthenticated, loadingMyUser } = useAuthContext();
  const [breadcrumbs, setBreadcrumbs] = useState([]);

  if (loadingMyUser ) {
    return (
      <Container className="d-flex align-items-center justify-content-center" style={{ height: "100vh" }}>
        <Spinner animation="border" role="status" className="text-secondary"/>
      </Container>
    )
  }
  
  return (
    <>
      <ApiErrorNotifier />
      { isAuthenticated === true && <SessionExpiryWarning /> }
      { isAuthenticated === true  ? (
        <Switch>
          <Route path="/dashboard" render={(props) => <DashboardLayout {...props} breadcrumbs={breadcrumbs} setBreadcrumbs={setBreadcrumbs} />} />
          <Route path="/payment/success" render={(props) => <PaymentSuccess {...props} />} />
          <Route path="/payment/cancelled" render={(props) => <PaymentCancelled {...props} />} />
          {devLoginEnabled && <Route path={DEV_LOGIN_PATH} component={DevLogin} />}
          <Redirect from="*" to="/dashboard/frontpage" />
        </Switch>
      ) : (
        <Switch>
          <Route path="/auth" render={(props) => <AuthLayout {...props} />} />
          {devLoginEnabled && <Route path={DEV_LOGIN_PATH} component={DevLogin} />}
          <Redirect from="*" to="/auth/login" />
        </Switch>
      )}
      
    </>
  )
}

export default App;